/* 🤖 this file was generated by svg-to-ts */
export const matIconHorizontalRule: {
  name: 'horizontal-rule';
  data: string;
} = {
  name: 'horizontal-rule',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M4 11h16v2H4z"/></svg>`
};
